export const azureOperationPaths = {
  list: (connectionId) =>
    `/compute/cloud-account-connections/${connectionId}/azure/operations`,
};
